import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CssBaseline } from "@mui/material";
import PricingFrame from "./PricingFrame";
import EnrollFrame from "../../elements/EnrollFrame";
import HeroSection from "../../elements/HeroSection";
import SparrowSection from "../approachPage/SparrowSection";

export interface IconTypographyI {
  isMobile: boolean;
  isSmallMobile: boolean;
  isShortScreen: boolean;
  text: string;
}

const PricingPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CssBaseline />
      <HeroSection
        mainTitle={<>{t("PricingPage.mainTitle")}</>}
        secondaryTitle={
          <>
            {t("PricingPage.secondaryTitle1")}
            <br />
            {t("PricingPage.secondaryTitle2")}
          </>
        }
        backgroundImageUrl={"/pricingPage/hero.webp"}
        altImage={t("AltImages.alt_image_pricing")}
        isPricingPage={true}
      />
      <PricingFrame />
      <SparrowSection
        image="/birds/blue.webp"
        title1={t("PricingPage.SparrowSection.title_1")}
        marginBottom={true}
        buttonText={t("PricingPage.SparrowSection.buttonText")}
      />
      <EnrollFrame />
    </>
  );
};

export default PricingPage;
